import { render, staticRenderFns } from "./xinxi.vue?vue&type=template&id=7093ecea&"
import script from "./xinxi.vue?vue&type=script&lang=js&"
export * from "./xinxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports